
















import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { UpdateUserChannel } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import Rules from '@/utils/rules'
import { getByParentId } from '@/store/classifyStore'
import { VImageUpload } from '@/components/upload'

@Component({
  components: {
    VImageUpload,
  },
})
export default class UpdateChannelDialog extends Vue {
  private show = false
  private data: any = {channelNo:'',channelName:''}
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    channelNo: [this.requiredRule],
    channelName: [this.requiredRule],
  }

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
    this.data = {channelNo:'',channelName:''}
  }
  public open(param: any) {
    this.show = true
    this.data.id = param.id
    this.data.channelNo = param.channelNo
    this.data.channelName = param.channelName
  }

  public async save() {
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      await UpdateUserChannel(this.data)
      Message.success('修改成功')
      this.close()
    })
  }
}
